import { useEffect, useRef } from 'react'

import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { $creatorId } from '@/models/creators.ts'
import { $hasAccessOnlyfansProfilePermission } from '@/models/permissions.ts'
import { chatsService } from '@/modules/chatting/service/chats.ts'

import { DialogProps } from '../types'

export const LoggedOutOFDialog = ({ isOpen }: DialogProps) => {
  const creatorId = useUnit($creatorId)
  const canLogin = useUnit($hasAccessOnlyfansProfilePermission)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const cleanUp = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }

    cleanUp()

    if (!creatorId) {
      return
    }

    intervalRef.current = setInterval(() => {
      chatsService.isLoggedIn(creatorId).then((loggedIn) => {
        if (loggedIn) {
          window.location.reload()
        }
      })
    }, 3000)

    return cleanUp
  }, [creatorId])

  return (
    <Dialog
      show={isOpen}
      bigDialog
      panelClassName="lg:max-w-[533px]"
    >
      <Dialog.Header>
        <Dialog.Title>You have been logged out</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description className="text-title mt-[8px] block text-center text-lg">
        The OnlyFans session expired or someone logged out. <br />
        {canLogin && 'Please login again to access the Chatting UI.'}
        {!canLogin &&
          'Please contact someone from your team who can access the OnlyFans profile and tell them to login again.'}
      </Dialog.Description>
      <Dialog.Description className="mt-6 block space-y-3" />
      {canLogin && (
        <Dialog.Footer>
          <Button
            className="w-full"
            onClick={() => {
              window.open(`https://onlyfans.com`, '_blank')
            }}
          >
            Login
          </Button>
        </Dialog.Footer>
      )}
    </Dialog>
  )
}
